"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Check = function Check(_ref) {
  var checked = _ref.checked,
      children = _ref.children,
      onMouseDown = _ref.onMouseDown,
      theme = _ref.theme,
      style = _ref.style;
  return _react["default"].createElement("div", {
    "data-react-toolbox": "check",
    className: (0, _classnames3["default"])(theme.check, _defineProperty({}, theme.checked, checked)),
    onMouseDown: onMouseDown,
    style: style
  }, children);
};

Check.propTypes = {
  style: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  checked: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  onMouseDown: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    check: _propTypes["default"].string,
    checked: _propTypes["default"].string
  }).isRequired
};
Check.defaultProps = {
  style: {},
  checked: false,
  onMouseDown: function onMouseDown() {},
  children: null
};

var Checkbox =
/*#__PURE__*/
function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (event) {
      if (event.pageX !== 0 && event.pageY !== 0) _this.blur();

      if (!_this.props.disabled && _this.props.onChange) {
        _this.props.onChange(!_this.props.checked, event);
      }
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "blur",
    value: function blur() {
      if (this.inputNode) {
        this.inputNode.blur();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.inputNode) {
        this.inputNode.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          checked = _this$props.checked,
          children = _this$props.children,
          disabled = _this$props.disabled,
          label = _this$props.label,
          name = _this$props.name,
          style = _this$props.style,
          onChange = _this$props.onChange,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          theme = _this$props.theme,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, ["checked", "children", "disabled", "label", "name", "style", "onChange", "onMouseEnter", "onMouseLeave", "theme", "className"]);

      var classNames = (0, _classnames3["default"])(theme.field, _defineProperty({}, theme.disabled, disabled), className);
      return _react["default"].createElement("label", {
        "data-react-toolbox": "checkbox",
        className: classNames,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, _react["default"].createElement("input", _extends({}, rest, {
        checked: checked,
        className: theme.input,
        disabled: disabled,
        name: name,
        onChange: function onChange() {},
        onClick: this.handleToggle,
        ref: function ref(node) {
          _this2.inputNode = node;
        },
        type: "checkbox"
      })), _react["default"].createElement(Check, {
        checked: checked,
        disabled: disabled,
        rippleClassName: theme.ripple,
        style: style,
        theme: theme
      }), label ? _react["default"].createElement("span", {
        "data-react-toolbox": "label",
        className: theme.text
      }, label) : null, children);
    }
  }]);

  return Checkbox;
}(_react.Component);

_defineProperty(Checkbox, "propTypes", {
  style: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  checked: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  theme: _propTypes["default"].shape({
    disabled: _propTypes["default"].string,
    field: _propTypes["default"].string,
    input: _propTypes["default"].string,
    ripple: _propTypes["default"].string
  }).isRequired
});

_defineProperty(Checkbox, "defaultProps", {
  style: {},
  checked: false,
  className: '',
  disabled: false,
  children: null,
  label: null,
  name: '',
  onChange: function onChange() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
});

var _default = (0, _ThemeProvider.applyTheme)('Checkbox', Checkbox);

exports["default"] = _default;